import React from 'react';
import { IconProps } from './types';

const PurpleCheck: React.FC<IconProps> = ({
  className,
  color = '#181B32',
  size = 32,
  ignoreColor,
}) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={size * 1}
    height={size}
    viewBox="0 0 31 31"
  >
   <circle cx="17" cy="17" r="14" fill="#6F4EF6"/>
<path d="M13.5 27C10.83 27 8.21987 26.2082 5.99981 24.7248C3.77974 23.2414 2.04941 21.133 1.02763 18.6662C0.00584929 16.1994 -0.261496 13.485 0.259405 10.8663C0.780305 8.24754 2.06606 5.84207 3.95406 3.95406C5.84207 2.06606 8.24754 0.780305 10.8663 0.259405C13.485 -0.261496 16.1994 0.00584929 18.6662 1.02763C21.133 2.04941 23.2414 3.77974 24.7248 5.99981C26.2082 8.21987 27 10.83 27 13.5C27 17.0804 25.5777 20.5142 23.0459 23.0459C20.5142 25.5777 17.0804 27 13.5 27ZM13.5 1.68751C11.1637 1.68751 8.87989 2.3803 6.93733 3.67827C4.99478 4.97624 3.48074 6.82111 2.58668 8.97956C1.69262 11.138 1.45869 13.5131 1.91448 15.8045C2.37027 18.0959 3.4953 20.2007 5.14731 21.8527C6.79931 23.5047 8.9041 24.6297 11.1955 25.0855C13.4869 25.5413 15.862 25.3074 18.0205 24.4133C20.1789 23.5193 22.0238 22.0052 23.3217 20.0627C24.6197 18.1201 25.3125 15.8363 25.3125 13.5C25.3125 10.3671 24.068 7.36258 21.8527 5.14731C19.6374 2.93203 16.6329 1.68751 13.5 1.68751Z" fill="white"/>
<path d="M10.9692 18.5625C10.8581 18.5631 10.7481 18.5419 10.6453 18.4999C10.5425 18.4579 10.449 18.396 10.3701 18.3178L6.15137 14.0991L7.34105 12.9094L10.9692 16.5291L19.6514 7.83844L20.8411 9.02813L11.5598 18.3094C11.404 18.4683 11.1917 18.5593 10.9692 18.5625Z" fill="white"/>
  </svg>
);

export default PurpleCheck;
